import { useTranslation } from './useTranslation';
import { NavItemConfig } from '@/app/constants/nav';
import { paths } from '@/app/constants/paths';

/**
 * Hook to get navigation items with translated labels
 * Dynamically updates when language changes
 */
export const useNavItems = (): NavItemConfig[] => {
    const { t } = useTranslation();

    return [
        {
            key: 'home',
            label: t('home'),
            title: t('home'),
            href: paths.home,
            icon: 'home'
        },
        {
            key: 'community',
            label: t('community'),
            title: t('community'),
            href: paths.community.challenges,
            icon: 'community'
        },
        {
            key: 'writing',
            label: t('writing'),
            title: t('writing'),
            href: paths.writing,
            icon: 'writing'
        },
        {
            key: 'store',
            label: t('store'),
            title: t('store'),
            href: paths.store,
            icon: 'store'
        },
        {
            key: 'mychannel',
            label: t('my_channel'),
            title: t('my_channel'),
            href: paths.mychannel.profile,
            icon: 'mychannel'
        },
    ];
};
